import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";

const tailwindIcon = {
  tailwind: {
    width: 24,
    height: 24,
    fill: "38bdf8",
    d: "M12 6.036c-2.667 0-4.333 1.325-5 3.976 1-1.325 2.167-1.822 3.5-1.491.761.189 1.305.738 1.906 1.345C13.387 10.855 14.522 12 17 12c2.667 0 4.333-1.325 5-3.976-1 1.325-2.166 1.822-3.5 1.491-.761-.189-1.305-.738-1.907-1.345-.98-.99-2.114-2.134-4.593-2.134zM7 12c-2.667 0-4.333 1.325-5 3.976 1-1.326 2.167-1.822 3.5-1.491.761.189 1.305.738 1.907 1.345.98.989 2.115 2.134 4.594 2.134 2.667 0 4.333-1.325 5-3.976-1 1.325-2.167 1.822-3.5 1.491-.761-.189-1.305-.738-1.906-1.345C10.613 13.145 9.478 12 7 12z",
  },
};

const logoIcon = {
  logo: {
    width: 94,
    height: 94,
    d: "M47,94C21.084,94,0,72.916,0,47S21.084,0,47,0s47,21.084,47,47S72.916,94,47,94z M47,12.186c-19.196,0-34.814,15.618-34.814,34.814c0,19.195,15.618,34.814,34.814,34.814c19.195,0,34.814-15.619,34.814-34.814C81.814,27.804,66.195,12.186,47,12.186z",
  },
};

export const IconsPlugin = {
  install(Vue) {
    Icon.register(tailwindIcon);
    Icon.register(logoIcon);
    Vue.component("v-icon", Icon);
  },
};
